module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.69c703b2.ttf";